/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
//@import BaseMoserObject (loadtime) // superclass

/**
 * Defines the object types in the model objects.  Each object type is the model class name.   They can be used to compare with the moser object types using <code>getObjectType()</code>.
 */
export default class MoserObjectTypes extends BaseMoserObject{

	static MOSER_OBJECT = "MoserObject";

	static PARAMETER_VALUE_SET = "ParameterValueSet";

	static TEXT_RESOURCE = "TextResource";

	static PHYSICAL_OBJECT_TYPE = "PhysicalObjectType";

	static VALIDATION_MESSAGE = "ValidationMessage";

	static FACET_TYPE = "FacetType";

	static PROMPT_INFO_TYPE = "PromptInfoType";

	static ITEM_TYPE = "ItemType";

	static QUERY_VALUE_SELECTOR = "QueryValueSelector";

	static INDEX = "Index";

	static PROPERTY_TYPE = "PropertyType";

	static COLUMN_DEPENDENCY = "ColumnDependency";

	static ITEM = "Item";

	static SORT_ITEM = "SortItem";

	static SECURITY_FILTER = "SecurityFilter";

	static CALCULATION = "Calculation";

	static QUERY_SUBJECT = "QuerySubject";

	static SPLIT_RULE = "SplitRule";

	static NAMED_SET = "NamedSet";

	static FOLDER_TYPE = "FolderType";

	static ITEM_HIERARCHY = "ItemHierarchy";

	static PROJECTED_ITEM_TYPE = "ProjectedItemType";

	static FOLDER_ITEM_TYPE = "FolderItemType";

	static PARAMETER_VALUE = "ParameterValue";

	static SPLIT_CONFIG = "SplitConfig";

	static USE_SPEC = "UseSpec";

	static PARAMETER_MAP = "ParameterMap";

	static BASE_OBJECT_TYPE = "BaseObjectType";

	static DATA_SOURCE = "DataSource";

	static PARAMETER_FEEDBACK_INFO = "ParameterFeedbackInfo";

	static SORT_EXPRESSION = "SortExpression";

	static FOCUS = "Focus";

	static JDBC = "Jdbc";

	static TAXONOMY_TYPE = "TaxonomyType";

	static LOCAL_REF_TYPE = "LocalRefType";

	static MODULE = "Module";

	static PARAMETER_MAP_ENTRY = "ParameterMapEntry";

	static ERROR_DATA = "ErrorData";

	static LINK = "Link";

	static KEY = "Key";

	static PARAMETER_CAPABILITIES_TYPE = "ParameterCapabilitiesType";

	static ATTRIBUTE = "Attribute";

	static DB_FUNCTION = "DbFunction";

	static PRIMARY_KEY = "PrimaryKey";

	static FOLDER = "Folder";

	static SEGMENT = "Segment";

	static STRUCT = "Struct";

	static OBJECT_TYPE = "ObjectType";

	static SQL_QUERY_TYPE = "SqlQueryType";

	static ITEM_NORMALIZATION_TYPE = "ItemNormalizationType";

	static FEEDBACK = "Feedback";

	static COLUMN = "Column";

	static SPLIT_TYPE = "SplitType";

	static PROC_PARAMETER_TYPE = "ProcParameterType";

	static DEF_LINK_TYPE = "DefLinkType";

	static SORT_LIST_TYPE = "SortListType";

	static QUERY_OPERATION = "QueryOperation";

	static MSG = "Msg";

	static CONTEXT = "Context";

	static QUERY_ITEM = "QueryItem";

	static TABLE = "Table";

	static TABLE_ITEM_TYPE = "TableItemType";

	static DRILL_GROUP = "DrillGroup";

	static CALCULATED_MEMBER_TYPE = "CalculatedMemberType";

	static VALUE_TYPE = "ValueType";

	static CARDINALITY_TYPE = "CardinalityType";

	static SECURITY_OBJECT = "SecurityObject";

	static ITEM_NORMALIZATION_GROUP_TYPE = "ItemNormalizationGroupType";

	static DATA = "Data";

	static FK_COLUMN = "FkColumn";

	static FOREIGN_KEY = "ForeignKey";

	static ANCESTORS = "Ancestors";

	static JOIN_OPERATION = "JoinOperation";

	static PARAMETER_FAULT = "ParameterFault";

	static STORED_PROCEDURE = "StoredProcedure";

	static MEMBER_TYPE = "MemberType";

	static FILTER = "Filter";

	static QUERY_ITEM_MAP = "QueryItemMap";

	static RELATIONSHIP = "Relationship";

	static INDEXED_COLUMN = "IndexedColumn";

	static MULTISET = "Multiset";

	static PROMPT = "Prompt";

	static BASE_QUERY_ITEM_TYPE = "BaseQueryItemType";


}


// WEBPACK FOOTER //
// ./src/generated/MoserObjectTypes.js